import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import Bids from './pages/bids'
import Collection from './pages/collection'
import Demo from './pages/demo'
import Home from './pages/index'
import Profile from './pages/profile'
import Saved from './pages/saved'
import SettingsProfile from './pages/settings-profile'
import Signin from './pages/signin'
import SignUp from './pages/signup'
import Wallet from './pages/wallet'
import SettingsApplication from './pages/settings-application'
import SettingsSecurity from './pages/settings-security'
import SettingsActivity from './pages/settings-activity'
import SettingsPayment from './pages/settings-payment-method'
import SettingsApi from './pages/settings-api'
import Lock from './pages/lock'
import Otp1 from './pages/otp1'
import Otp2 from './pages/otp2'
import VerifyEmail from './pages/verify-email'
import Reset from './pages/reset'

export default function MainRouter() {
    return (
        <>
            <BrowserRouter>
                <Routes>
                    <Route path='/' exact element={<Home />} />
                    <Route path="/bids" element={<Bids />} />
                    <Route path="/saved" element={<Saved />} />
                    <Route path="/collection" element={<Collection />} />
                    <Route path="/wallet" element={<Wallet />} />
                    <Route path="/profile" element={<Profile />} />
                    <Route path="/settings-profile" element={<SettingsProfile />} />
                    <Route path="/signin" element={<Signin />} />
                    <Route path="/collection" element={<Collection />} />
                    <Route path="/demo" element={<Demo />} />
                    <Route path="/signin" element={<Signin />} />
                    <Route path="/signup" element={<SignUp />} />
                    {/* <Route path="/bids" />
                    <Route path="/saved" /> */}
                    {/* <Route path="/collections" /> */}
                    {/* <Route path="/wallet" /> */}
                    {/* <Route path="/profile" /> */}
                    {/* <Route path="/settings-profile" /> */}
                    <Route path="/settings-application" element={<SettingsApplication/>} />
                    <Route path="/settings-security" element={<SettingsSecurity/>} />
                    <Route path="/settings-activity" element={<SettingsActivity/>} />
                    <Route path="/settings-payment-method" element={<SettingsPayment/>} />
                    <Route path="/settings-api" element={<SettingsApi/>} />
                    <Route path="/lock" element={<Lock />} />
                    <Route path="/otp1" element={<Otp1/>} />
                    <Route path="/otp2" element={<Otp2/>} />
                    <Route path="/verify-email" element={<VerifyEmail/>} />
                    <Route path="/reset" element={<Reset/>} />
                </Routes>
            </BrowserRouter>
        </>

    )
}
